module.exports = __webpack_public_path__ + "img/cat-03-in.5bf40dd6.svg";